import React from 'react';
import { Modal } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCreditCard } from '@fortawesome/free-solid-svg-icons';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import classes from './deposit-return-modal.module.scss';
import { Button } from '../../../../../components/Button/Button';
import navyModal from '../../../../../components/Modal/navy-modal.module.scss';

export type DepositReturnModalProps = {
  opened: boolean;
  onClose: () => void;
  tableNumber: string | null;
};

// Summary: Payment-screen reminder to return the customer's card left as deposit (פיקדון).
// Details: docs/function-library/web/contexts-pages.md#pages-posshellpage-components-receipt
const DepositReturnModalComponent: React.FC<DepositReturnModalProps> = ({
  opened,
  onClose,
  tableNumber,
}) => {
  const message =
    tableNumber !== null && tableNumber !== ''
      ? `החזר ללקוח שולחן ${tableNumber} את כרטיס האשראי שהותיר כפיקדון`
      : 'לא לשכוח להחזיר ללקוח את כרטיס האשראי שהותיר כפיקדון';

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="תזכורת"
      size="sm"
      centered
      radius="md"
      dir="rtl"
      classNames={{ root: `${classes.modalRoot} ${navyModal.root}` }}
      withCloseButton={false}
      closeOnClickOutside={false}
      closeOnEscape={false}
    >
      <div className={classes.body}>
        <span className={classes.badge}>
          <FontAwesomeIcon icon={faCreditCard as IconProp} />
          פיקדון פעיל
        </span>
        <p className={classes.message}>{message}</p>
        <Button variant="confirm" onClick={onClose} fullWidth dataTestId="deposit-return-confirm">
          אישור
        </Button>
      </div>
    </Modal>
  );
};

export const DepositReturnModal = React.memo(DepositReturnModalComponent);
